import { render, staticRenderFns } from "./ElSavitarnaAlert.vue?vue&type=template&id=3d929044&scoped=true&"
import script from "./ElSavitarnaAlert.vue?vue&type=script&lang=js&"
export * from "./ElSavitarnaAlert.vue?vue&type=script&lang=js&"
import style0 from "./ElSavitarnaAlert.vue?vue&type=style&index=0&id=3d929044&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d929044",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
installComponents(component, {VAlert})
